'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/lib/locate/escape.js
// module id = 387
// module chunks = 0